<template>
  <div class="tw-shadow-md tw-rounded-l-full tw-bg-white">
    <div class="tw-bg-white tw-absolute tw-w-28 tw-h-28"></div>
    <div class="tw-container tw-mx-auto text-center tw-p-5">
      <router-link to="/">
        <img src="/images/logo_phasi_charoen.svg" alt="ภาษีเจริญ" class="tw-mx-auto tw-mb-10 tw-w-36"/>
      </router-link>
      <div>
        <h1 class="tw-text-sm md:tw-text-2xl tw-font-bold">{{ this.headerText }}</h1>
        <p class="tw-text-sm md:text-md tw-mt-2">{{ this.headerSubText }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AppBarCompanyList',
  props: ['headerText', 'headerSubText'],
  components: {},
  methods: {}
}
</script>
